"use client";

import { iHolidayQuoteX } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { QuoteContentSection } from "../content-section";
import { ItinerarySection } from "../itinerary-section";
import { ItinerarySummaryVariant } from "../itinerary-summary";
import { isTripMode } from "../trip-mode/partition-itinerary-for-trip-mode";
import { TripModePageContent } from "../trip-mode/trip-mode-page-content";
import { QuotePageContentLayout } from "./quote-page-content-layout";

export interface QuotePageMainContentProps {
  quote: iHolidayQuoteX;
  itinerarySummaryVariant?: ItinerarySummaryVariant;
  pricingMode?: "grid" | "grid-asymmetric" | "sidebar";
}

export function QuotePageMainContent({
  quote,
  itinerarySummaryVariant = "default",
  pricingMode = "grid",
}: QuotePageMainContentProps) {
  if (isTripMode(quote.data?.mode)) {
    return <TripModePageContent quote={quote} pricingMode={pricingMode} />;
  }

  return (
    <QuotePageContentLayout
      quote={quote}
      itinerarySummaryVariant={itinerarySummaryVariant}
      pricingMode={pricingMode}
      preItinerary={<QuoteContentSection blocks={quote.preItineraryBlocks} />}
      itinerary={<ItinerarySection itinerary={quote.itineraryBlocks || []} />}
      postItinerary={<QuoteContentSection blocks={quote.postItineraryBlocks} />}
      pricing={<QuoteContentSection blocks={quote.pricingBlocks} />}
      postPricing={<QuoteContentSection blocks={quote.postPricingBlocks} />}
    />
  );
}
